/** redux-saga */
import { all, call, put, select, takeLatest } from "redux-saga/effects";

/** action types */
import {
  STORE_VIDEO_DEVICE_ID,
  GET_STORED_VIDEO_DEVICE_ID,
} from "../constants/ActionTypes";

/** actions */
import { setVideoDeviceId } from '../actions/Scanner';

/** constants */
import { STORAGE_VIDEO_DEVICE_ID_KEY } from '../constants/Scanner';

/** retrieve value from localStorage */
const getVideoDeviceIdFromStorage = () => {
  try {
    const videoDeviceId = localStorage.getItem(STORAGE_VIDEO_DEVICE_ID_KEY) ?? '';
    return videoDeviceId;
  }
  catch (e) {
    // May fail in private browser, storage full, unavailable, etc.
    console.error(e);
  }

  return null;
}

/** put value in localStorage */
const storeVideoDeviceIdInStorage = (videoDeviceId) => {
  try {
    localStorage.setItem(STORAGE_VIDEO_DEVICE_ID_KEY, videoDeviceId);
  } catch (e) {
    // May fail in private browser, storage full, unavailable, etc.
    console.error(e);
  }
}

function* getVideoDeviceId() {
  try {
    const storageVideoDeviceId = yield call(getVideoDeviceIdFromStorage);
    const storeVideoDeviceId = yield select(store => store.scanner.videoDeviceId);
    // console.log('SAGA getVideoDeviceId storageVidId: ', storageVideoDeviceId, ' storeVidId: ', storeVideoDeviceId);
    yield put(setVideoDeviceId(storageVideoDeviceId));
  }
  catch (error) {
    console.error('getVideoDeviceId saga generator:', error);
  }
}

function* storeVideoDeviceId(storeVideoAction) {
  try {
    const { payload: videoDeviceId } = storeVideoAction || {};
    // console.log('SAGA storeVideoDeviceId videoDeviceId: ', storeVideoAction);
    yield call(storeVideoDeviceIdInStorage, videoDeviceId)
    yield put(setVideoDeviceId(videoDeviceId));
  }
  catch (error) {
    console.error('storeVideoDeviceId saga generator:', error);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(STORE_VIDEO_DEVICE_ID, storeVideoDeviceId),
    takeLatest(GET_STORED_VIDEO_DEVICE_ID, getVideoDeviceId)
  ]);
}
